import React, {useEffect, useState} from 'react'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {Model} from 'helpers'
import {fetchBuyerDetails} from 'utils/api/auth/orderManagementService'
import {ICustomerDetails} from 'models/OrderManagement'
import {formatNumberForDisplay} from 'utils/helper'

type IProps = {
 loggedInUserId: number | undefined
 aggregatorId: number | null
 setAggregatorId: (id: number | null) => void
 setLoader: (newState: boolean) => void
}

const CustomerDetails = (props: IProps) => {
 const {t} = useTranslation()
 const [showBuyerModel, setShowBuyerModel] = useState(false)
 const [customerData, setSetCustomerData] =
  useState<ICustomerDetails | null>(null)

 const getBuyerDetails = async () => {
  props.setLoader(true)
  const res: ICustomerDetails | null =
   await fetchBuyerDetails({
    aggregator_id: props.aggregatorId,
   })
  if (res) {
   setSetCustomerData(res)
   setShowBuyerModel(true)
  } else {
   setSetCustomerData(null)
  }
  props.setLoader(false)
 }

 useEffect(() => {
  if (props.aggregatorId) {
   void getBuyerDetails()
  } else {
   setShowBuyerModel(false)
  }
 }, [props.aggregatorId])

 return (
  <>
   <Model
    show={showBuyerModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     props.setAggregatorId(null)
    }}
    modelClass='md:w-[600px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <p className='text-[#171B1F] text-left font-bold text-2xl border-b border-[#E6EBF0] pb-6 mb-6'>
      {customerData?.customer_name}
     </p>
     <div className='w-full mt-7 text-[#33393D] font-normal text-lg'>
      <div className='w-full mb-6'>
       <p className='text-[#4E83E4] font-medium text-xs'>
        {t('orderManagement.customerDetails.address')}
       </p>
       <p>{customerData?.address}</p>
      </div>
      <div className='w-full mb-4'>
       <p className='text-[#4E83E4] font-medium text-xs'>
        {t('orderManagement.customerDetails.mobile')}
       </p>
       <p>{customerData?.contact_number}</p>
      </div>
      {/* <div className='grid gap-2 md:grid-cols-2 mb-4'>
       <div>
        <p className='text-[#5A6066] font-medium'>
         {t(
          'orderManagement.customerDetails.sanctionedCredit'
         )}
        </p>
        <p className='text-2xl'>
         <i className='fa fa-inr pr-0.5'></i>
         {formatNumberForDisplay(
          Number(customerData?.credit_sanctioned)
         )}
        </p>
       </div>
       <div>
        <p className='text-[#5A6066] font-medium'>
         {t(
          'orderManagement.customerDetails.availableCredit'
         )}
        </p>
        <p className='text-2xl'>
         <i className='fa fa-inr pr-0.5'></i>
         {formatNumberForDisplay(
          Number(customerData?.current_available_credit)
         )}
        </p>
       </div>
      </div> */}
      <div className='grid gap-2 md:grid-cols-2 mb-4'>
       <div>
        <p className='text-[#5A6066] font-medium'>
         {t(
          'orderManagement.customerDetails.inlastSixMonth'
         )}
        </p>
        <p className='text-2xl'>
         <i className='fa fa-inr pr-0.5'></i>
         {formatNumberForDisplay(
          Number(customerData?.business_in_last_6_months)
         )}
        </p>
       </div>
       <div>
        <p className='text-[#5A6066] font-medium'>
         {t(
          'orderManagement.customerDetails.inlastOneYear'
         )}
        </p>
        <p className='text-2xl'>
         <i className='fa fa-inr pr-0.5'></i>
         {formatNumberForDisplay(
          Number(customerData?.business_in_last_year)
         )}
        </p>
       </div>
      </div>
      {/* <div className='mb-6'>
       <p className='text-[#5A6066] font-medium'>
        {t('orderManagement.customerDetails.outstanding')}
       </p>
       <p className='text-2xl'>
        <i className='fa fa-inr pr-0.5'></i>
        {formatNumberForDisplay(
         Number(customerData?.outstanding)
        )}
       </p>
      </div> */}
     </div>
     <div className='md:flex items-center justify-center mt-12'>
      <Button
       type={'button'}
       onClick={() => {
        props.setAggregatorId(null)
       }}
       color='blue'
       className='disabled:text-white text-center w-full py-[9px] px-6 bg-[#4E83E4] 
                             !rounded-lg !text-base text-white font-semibold border-[#4E83E4]'
      >
       {t('common.okay')}
      </Button>
     </div>
    </div>
   </Model>
  </>
 )
}

export default CustomerDetails
